import { CmsHelpTrainingList } from '../../../components/Cms';

export function HelpLayout() {
  return <CmsHelpTrainingList />;
}
